var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRewardsLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo_Grad",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#334052;}.cls-3{fill:url(#linear-gradient-8);}.cls-4{fill:url(#linear-gradient-9);}.cls-5{fill:url(#linear-gradient-3);}.cls-6{fill:url(#linear-gradient-4);}.cls-7{fill:url(#linear-gradient-2);}.cls-8{fill:url(#linear-gradient-6);}.cls-9{fill:url(#linear-gradient-7);}.cls-10{fill:url(#linear-gradient-5);}.cls-11{fill:url(#linear-gradient-10);}.cls-12{fill:url(#linear-gradient-11);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 30.33,
    x2: 113.13,
    y1: 65.33,
    y2: -73.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0089bc",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#493885",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 37.73,
    x2: 120.53,
    y1: 69.75,
    y2: -68.92,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 105.21,
    x2: 188.01,
    y1: 110.04,
    y2: -28.63,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 81.95,
    x2: 164.76,
    y1: 96.16,
    y2: -42.51,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 135.41,
    x2: 218.21,
    y1: 104.64,
    y2: -34.03,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 166.76,
    x2: 249.57,
    y1: 123.36,
    y2: -15.31,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 201.02,
    x2: 283.82,
    y1: 143.81,
    y2: 5.14,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 247.83,
    x2: 330.64,
    y1: 171.77,
    y2: 33.1,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 276.57,
    x2: 359.37,
    y1: 188.93,
    y2: 50.26,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 307.1,
    x2: 389.9,
    y1: 207.16,
    y2: 68.49,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 343.33,
    x2: 426.13,
    y1: 228.79,
    y2: 90.12,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient1148",
    x1: 30.33,
    x2: 113.13,
    y1: 65.33,
    y2: -73.34,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.46827 0 0 .46827 8.2972 .14229)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m23.72 84.14c2.93 1.14 5.92 2.07 8.94 2.78 1.01 0.24 2.02 0.45 3.04 0.64 2.03 0.38 4.08 0.67 6.13 0.86s4.11 0.29 6.17 0.29c4.12 0 8.24-0.38 12.31-1.14s8.08-1.9 11.98-3.43l14.6-5.7s0.02 0 0.04-0.01c11.54-7.66 19.16-20.76 19.16-35.65 0-23.62-19.16-42.78-42.79-42.78h-63.3v74.93c0.12 0.04 0.24 0.06 0.37 0.11l23.35 9.11zm25.45-59.79c12.1 0 21.92 9.81 21.92 21.92s-9.81 21.92-21.92 21.92-21.92-9.81-21.92-21.92 9.81-21.92 21.92-21.92z",
    fill: "url(#linearGradient1148)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "0 153.15 16.7 153.15 24.76 101.89 0 84.74",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "79.3 153.15 118.32 153.15 90.81 88.33 71.22 101.89",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m37.83 141.83-6.6 11.32h33.54l-6.6-11.32c-4.54-7.8-15.81-7.8-20.35 0z",
    fill: "url(#linear-gradient-4)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardsLogo);
export default __webpack_public_path__ + "f1dfc8898588b1db80964926597c9555.svg";
export { ForwardRef as ReactComponent };